import BreadcrumbDates from "../../../../components/core/blocks/BreadcrumbDates";
import { AmcInstanceDetails } from "../../../../modules/amc/components/instance/AmcInstanceDetails";
import { DASHBOARD_LINKS } from "../../../../utils/dashboardLinks";
import { useModuleEnabled } from "../../../../redux/selectors/modules";
import { Navigate, createFileRoute } from "@tanstack/react-router";
import AudiencesSection from "../../../../modules/amc/components/audience/AudiencesSection";
import { AMC_QUERY_EXPLORER_BREADCRUMB_SPEC } from "../../../../modules/amc/utils/utils";
import AMCAudienceDetails from "../../../../views/amc/audience/AMCAudienceDetails";
import { Tabs, TabList, Tab, TabPanel } from "../../../../components/core/basic/Tabs";
import useQueryParams from "../../../../hooks/useQueryParams";
import { PageContainer } from "../../../../components/core/basic/PageContainer";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const AudienceDashboard = () => {
  const hasAMCModule = useModuleEnabled("AMC");
  const [tab, setTab] = useQueryParams("tab", "create");
  const { t } = useTranslation(["amc"]);

  const breadCrumbItems = [
    {
      name: t(($) => $.amc["AMC Dashboard"]),
      href: "/user/amc/dashboard",
      unsorted: true,
      dropdownLinkOptions: DASHBOARD_LINKS,
      dropdownSubtitle: t(($) => $.amc["Reports"]),
    },
  ];

  if (!breadCrumbItems[0].dropdownLinkOptions?.find((o) => o.name === AMC_QUERY_EXPLORER_BREADCRUMB_SPEC.name)) {
    breadCrumbItems[0].dropdownLinkOptions.push(AMC_QUERY_EXPLORER_BREADCRUMB_SPEC);
  }

  if (!hasAMCModule) {
    return <Navigate to="/user/dashboard" replace />;
  }

  return (
    <>
      <BreadcrumbDates items={breadCrumbItems} hideDateSelector={true}>
        <AmcInstanceDetails />
      </BreadcrumbDates>
      <PageContainer>
        <Container>
          <h1 className="text-center pt-4" style={{ fontWeight: 600, fontSize: "24px" }}>
            {t(($) => $.amc["AMC Audiences"])}
          </h1>
          <Tabs selectedKey={tab} onSelectionChange={setTab}>
            <TabList>
              <Tab id="create">{t(($) => $.amc["Templates"])}</Tab>
              <Tab id="audiences">{t(($) => $.amc["Audiences"])}</Tab>
            </TabList>
            <TabPanel id="create">
              <AudiencesSection />
            </TabPanel>
            <TabPanel id="audiences">
              <AMCAudienceDetails />
            </TabPanel>
          </Tabs>
        </Container>
      </PageContainer>
    </>
  );
};

export const Route = createFileRoute("/_authenticated/user/audience/dashboard")({
  component: AudienceDashboard,
  staticData: { application: "Advertising" },
});
